/**
 * NAT 정책 셋트 store
 *
 * @since 2018-08-06
 * @author kdydesign.kim
 */

import {SecutiryPolicyApiPrefix as objApiPrefix} from 'utils'

export const state = () => ({
  natPolicySetList: []
})

export const mutations = {
  // NAT 정책 셋트 조회
  getNatPolicySet (state, data) {
    state.natPolicySetList = data
  },

  // NAT 정책 셋트 추가
  setNatPolicySet (state, data) {
    state.natPolicySetList.push(data)
  },

  // NAT 정책 셋트 추가 - 정책에서의 임시 저장 시
  setTempStoragePolicySet (state, data) {
    state.natPolicySetList = _.map(state.natPolicySetList, (o) => {
      o.use = 0

      return o
    })

    state.natPolicySetList.push(data)
  },

  // NAT 정책 셋트 삭제
  deleteNatPolicySet (state, data) {
    const natPolicySetList = state.natPolicySetList
    const itemIndex = _.indexOf(natPolicySetList, data)

    natPolicySetList.splice(itemIndex, 1)
  },

  // NAT 정책 셋트 열기
  openNatPolicySet (state, data) {
    state.natPolicySetList = _.map(state.natPolicySetList, (o) => {
      if (o.nat_set_id === data.nat_set_id) {
        o = data
      } else {
        _.assign(o, {use: 0})
      }
      return o
    })
  }
}

export const actions = {
  // NAT 정책 셋트 조회
  async getNatPolicySet ({commit}) {
    const {code, result} = await this.$axios.$get(`${objApiPrefix}/nat/sets`)

    if (code === 'ok') {
      commit('getNatPolicySet', result)
    }
  },

  // 다른 이름으로 저장
  async saveAsNatPolicySet ({commit, state}, {name}) {
    const openSetId = _.find(state.natPolicySetList, {use: 1}).nat_set_id
    const {code, result} = await this.$axios.$put(`${objApiPrefix}/nat/sets/${openSetId}`, {
      nat_set_new_name: name
    }, {
      alertMsg: window.$nuxt.$t('msg.addApply')
    })

    if (code === 'ok') {
      commit('setNatPolicySet', result)

      return result
    }
  },

  // NAT 정책 셋트 추가
  async setNatPolicySet ({commit, state}, natPolicySettings) {
    const {code, result} = await this.$axios.$post(`${objApiPrefix}/nat/sets`, natPolicySettings, {
      successAlert: false,
      loadingHide: false
    })

    if (code === 'ok') {
      commit('setNatPolicySet', result)

      return result
    }
  },

  // NAT 정책 셋트 삭제
  async deleteNatPolicySet ({commit, state}, policySet) {
    const {code} = await this.$axios.$delete(`${objApiPrefix}/nat/sets/${policySet.nat_set_id}`)

    if (code === 'ok') {
      commit('deleteNatPolicySet', policySet)
    }
  },

  // NAT 정책 셋트 열기
  async openNatPolicySet ({commit, state}, {policySet, loadingShow = true, loadingHide = true}) {
    const {code, result} = await this.$axios.$put(`${objApiPrefix}/nat/sets/${policySet.nat_set_id}/use`, {use: 1}, {
      successAlert: false,
      loadingShow,
      loadingHide
    })

    if (code === 'ok') {
      commit('openNatPolicySet', result)
    }
  }
}

export const getters = {
  // NAT 정책 셋트 데이터
  parseGetNatPolicySet (state) {
    const data = state.natPolicySetList

    const parseData = _.map(data, (o) => {
      if (o.use === 1) {
        o = _.assign(o, {parseUse: window.$nuxt.$t('cmn.used')})
      } else {
        o = _.assign(o, {parseUse: window.$nuxt.$t('cmn.unUsed')})
      }

      return o
    })

    return parseData
  },

  // 현재 사용중인 정책 셋트
  getCurrentNatRuleSet (state) {
    const result = _.find(state.natPolicySetList, {use: 1})

    if (result) {
      return result
    } else {
      return {
        name: ''
      }
    }
  }
}

export const strict = false
